<template>
    <div class="animated revealUp">
      <div class="white-wrapper">
        <div class="d-flex justify-content-between">
          <div class="section-title">
            {{ $t("Cashier Analysis Report") }}
            
          </div>
          <div class="d-flex align-items-center">
            
            <div class="d-flex align-item-center">
                  <input value="1" type="radio" v-model="lang_id">
                  <span class="ml-1">English</span>
                </div>
                <div class="d-flex align-item-center ml-2">
                <input value="2" type="radio" v-model="lang_id">
  
                <span class="ml-1">العربية</span>
              </div>
          </div>
        </div>
        <small><em>{{ $t("* As Per Transaction Date") }}</em></small>
        <div class="mt-3 mb-2">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-3 col-xl-3 align-self-center mb-3">
              <div class="dropdown-curve-container">
                <label
                  :class="
                     dropDown.selectedCinema && dropDown.selectedCinema.hasOwnProperty('cine_id')
                      ? 'shift-up'
                      : 'font-weight-bold'
                  "
                  >{{ $t("select") }} {{ $tc("cinema") }}</label
                >
                <multiselect
                  :disabled="isRoleID"
                  :options="dropDown.cinemas"
                  v-model="dropDown.selectedCinema"
                  :searchable="true"
                  label="cine_name"
                  track-by="cine_id"
                  placeholder=""
                  @input="onSelectCinema($event)"
                  :allowEmpty="false"
                  :showLabels="false"
                ></multiselect>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
              <div class="dropdown-curve-container">
                <label
                  :class="
                     selectedScreen && selectedScreen.length > 0
                      ? 'shift-up'
                      : 'font-weight-bold'
                  "
                  >{{ $t("select") }} {{ $t("screens") }}</label
                >
                <multiselect
                  :options="screenList"
                  v-model="selectedScreen"
                  placeholder=""
                  label="screen_name"
                  :multiple="true"
                  :close-on-select="false"
                  track-by="screen_id"
                ></multiselect>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <!-- <button class="btn-clearDate" v-if="fromDate">
                              ✖
                            </button> -->
                  <Datepicker
                    :monday-first="true"
                    type="date"
                    ref="programaticOpen"
                    v-model="fromDate"
                    v-validate="'required'"
                      @selected="onChangeDate($event, 'from')"
                       :disabled-dates="disablePastDates"
                  ></Datepicker>
                  <label :class="fromDate ? 'active' : ''">
                    <!-- {{ $t("show") }} -->
                    {{ $t("fromdate") }}
                  </label>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <!-- <button class="btn-clearDate" v-if="toDate">
                              ✖
                            </button> -->
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="toDate"
                    v-validate="'required'"
                      :disabled="true" 
                  >
                  </Datepicker>
                  <label :class="toDate ? 'active' : ''">
                    <!-- {{ $t("show") }}  -->
                    {{ $t("todate") }}</label
                  >
                </div>
              </div>
            </div>

                <!-- show time filter -->
                            <div class="position-relative col-lg-3 col-xl-2 mb-2">
                                             <vue-timepicker manual-input
                                              v-model="start_time"
                                               id="starttime"
                                               name="starttime"
                                               :placeholder="$tc('starttime')"
                                               format="HH:mm" 
                                               class="time_picker" 
                                               input-width="100%" auto-scroll
                                               lazy ></vue-timepicker>
                                           </div>
                              
                         
                                   <div class="position-relative col-lg-3 col-xl-2 mb-2">
                           <vue-timepicker
                             manual-input
                             v-model="end_time"
                             id="endtime"
                             name="endtime"
                             :placeholder="$tc('endtime')"
                             format="HH:mm"
                             class="time_picker"
                             input-width="100%"
                             auto-scroll
                             lazy
                           />
                         </div>
                        <!-- show time filter -->

                        <!-- Movie Filter -->
                          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                                   <div class="dropdown-curve-container">
                                     <label :class="allMovieNames.length > 0 ? 'shift-up' : 'font-weight-bold'">{{
                                       $t("Movie Name")
                                     }}</label>
                                     <multiselect v-model="selectedMovieName" :options="allMovieNames" track-by="movie_name"
                                       label="movie_name" :disabled="isRoleID" :searchable="true" placeholder="Movies" :multiple="true">
                                     </multiselect>
                                   </div>
                                 </div>
                        <!-- Movie Filter -->

  
            <div class="col-12 col-md-6 col-lg-6 col-xl-2 align-self-center mb-3">
              <button class="btn-blue-lg w-100" @click="onSubmit">
                {{ $t("fetch") }}
              </button>
            </div>
          </div>
        </div>
        <div
          v-if="showData.length > 0"
          class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
        >
          <div class="mx-1">{{ $t("download") }} {{ $t("as") }}</div>
       
          <img
              @click="getCashierSettlementReport('Y','N')"
                  class="cursor-pointer"
                  height="25"
                  src="@/assets/img/icons/pdf-icon.svg"
                  width="25"
                />
  
                <img  @click="getCashierSettlementReport('N','Y')" class="cursor-pointer ml-1"
                height="25" src="@/assets/img/icons/excel.svg" width="25" />
        </div>
  
          <div
            class="swc-report"
          >
            <table
            class="swc-report-table"
            :class="lang_id==2?'swc-report-table reverse-order ':'swc-report-table order '"  
              border="1"
            >
              <thead class="bg-lightgrey">
                <tr>
                  <th>{{  trans("cashier",lang_id) }}</th>
                  <th>{{  trans("screen",lang_id) }}</th>
                  <th>{{  trans("bookingchannels",lang_id) }}</th>
                  <th>{{ trans("paymentmethods",lang_id) }}</th>
                  <th>{{ trans("tickets",lang_id)}}</th>
                  <th>{{ trans("ticketsrevenue",lang_id) }}</th>
                  <th>{{ trans("3dglasses",lang_id) }}</th>
                  <th>{{ trans("3dglassesrevenue",lang_id) }}</th>
                </tr>
              </thead>
            
              <tbody v-if="showData.length">
  <template v-for="(user, userIndex) in showData">
    <template v-for="(screen, screenIndex) in user.userData">
      <template v-for="(source, sourceIndex) in screen.screenData">
        <template v-for="(mode, modeIndex) in source.bookingSourceData">
          <template v-for="(payment, paymentIndex) in mode.paymentModeData">
            <tr>
              <!-- USERNAME -->
              <td v-if="screenIndex==0 && sourceIndex==0 && modeIndex==0" :rowspan="getRowspanForUser(user)"
                  >
                {{ user.username }}
              </td>

              <!-- SCREEN NAME -->
              <td v-if="sourceIndex==0 && modeIndex==0" :rowspan="getRowspanForScreen(screen)">
                {{ lang_id==1?screen.screen_name:screen.screen_name_2?screen.screen_name_2:screen.screen_name }}
              </td>

              <!-- BOOKING SOURCE -->
              <td v-if="modeIndex==0" :rowspan="getRowspanForSource(source)">
                {{ source.bs_source }}
              </td>

              <!-- PAYMENT MODE -->
              <td class="text-left"  :rowspan="getRowspanForPaymentMode(mode)">
                {{ mode.pm_payment_mode }}
              </td>

              <!-- PAYMENT DATA -->
              <td class="text-right">{{ payment.tickets_no }}</td>
              <td class="text-right">{{ payment.tickets_gross }}</td>
              <td class="text-right">{{ payment.total_3d_tickets }}</td>
              <td class="text-right">{{ payment.total_3d_charge }}</td>
            </tr>
          </template>

      
        </template>

        <!-- TOTAL FOR BOOKING SOURCE -->
        <tr class="dark-blue">
          <td colspan="2" :class="lang_id==1?'text-left':'text-right'"><strong>{{trans("total",lang_id)}} ({{ source.bs_source }})</strong></td>
          <td class="text-right"><strong>{{ source.bookingSourceGrandTotal.total_tickets }}</strong></td>
          <td class="text-right"><strong>{{ source.bookingSourceGrandTotal.total_tickets_gross }}</strong></td>
          <td class="text-right"><strong>{{ source.bookingSourceGrandTotal.total_3d_tickets }}</strong></td>
          <td class="text-right"><strong>{{ source.bookingSourceGrandTotal.total_3d_charge }}</strong></td>
        </tr>
      </template>

      <!-- TOTAL FOR SCREEN -->
      <tr class="dark-blue">
        <td colspan="3" :class="lang_id==1?'text-left':'text-right'"><strong>{{trans("total",lang_id)}} ({{  lang_id==1?screen.screen_name:screen.screen_name_2?screen.screen_name_2:screen.screen_name}})</strong>
          <br />
          <span class="text-muted">Without(Invitation,Online)</span>
        </td>
       
        <td class="text-right"><strong>{{ screen.screenGrandTotal.total_tickets }}</strong></td>
        <td class="text-right"><strong>{{ screen.screenGrandTotal.total_tickets_gross }}</strong></td>
        <td class="text-right"><strong>{{ screen.screenGrandTotal.total_3d_tickets }}</strong></td>
        <td class="text-right"><strong>{{ screen.screenGrandTotal.total_3d_charge }}</strong></td>
      </tr>
    </template>

    <tr class="dark-blue">
      <td colspan="4" :class="lang_id==1?'text-left':'text-right'"><strong>{{trans('total',lang_id)}} ({{ user.username }})</strong>
        <br />
        <span class="text-muted">Without(Invitation,Online)</span>
      </td>
     
      <td class="text-right"><strong>{{ user.userGrandTotal.total_tickets }}</strong></td>
      <td class="text-right"><strong>{{ user.userGrandTotal.total_tickets_gross }}</strong></td>
      <td class="text-right"><strong>{{ user.userGrandTotal.total_3d_tickets }}</strong></td>
      <td class="text-right"><strong>{{ user.userGrandTotal.total_3d_charge }}</strong></td>
    </tr>
  </template>

  <!-- GRAND TOTAL -->
  <tr class="dark-blue">
    <td colspan="4" :class="lang_id==1?'text-left':'text-right'"><strong>{{ trans("overAllTotal",lang_id) }}</strong>
      <br />
      <span class="text-muted">Without(Invitation,Online)</span>
    </td>
    <td class="text-right"><strong>{{ grandTotal.total_tickets }}</strong></td>
    <td class="text-right"><strong>{{ grandTotal.total_tickets_gross }}</strong></td>
    <td class="text-right"><strong>{{ grandTotal.total_3d_tickets }}</strong></td>
    <td class="text-right"><strong>{{ grandTotal.total_3d_charge }}</strong></td>
  </tr>
</tbody>
  
        <tbody v-else>
            <tr>
                <td colspan="7">No Records</td>
            </tr>
        </tbody>
   
              <tbody v-else>
                <td colspan="11">No Records</td>
              </tbody>
            </table>
          </div>
      </div>
    </div>
  </template>
      
      <script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/NewReportService";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import CinemasService from "@/services/CinemasService";
  import NewReportService from "../../../services/NewReportService";
  import xlsx from "json-as-xlsx";
  import VueHtml2pdf from "vue-html2pdf";
  import * as XLSX from "xlsx";
  import { mapState, mapActions } from "vuex";
  // import LangSwitcher from "./LangSwitcher.vue";
     import VueTimepicker from "vue2-timepicker";
    import "vue2-timepicker/dist/VueTimepicker.css";
  
  export default {
    components: {
      NoRecords,
      VueHtml2pdf,
      // LangSwitcher,
      VueTimepicker
    },
    data() {
      return {
        selectedMovieName: [],
      allMovieNames: [],
        BASEURL,
        isRoleID: false,
        submitted: false,
        htmlToPdfOptions: {
          filename: this.pdfFileName,
          margin: 3,
          image: {
            type: "jpeg",
            quality: 1,
          },
          html2canvas: {
            scale: 1,
            useCORS: true,
          },
          jsPDF: {
            format: "a2",
            orientation: "landscape",
          },
        },
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
          selectedCinemaAddres: null,
        },
        fromDate: null,
        toDate: null,
        advancedSalesrecords: [],
        grandTotal: {},
        screenData: [],
        showData:[],
        selectedScreen: [],
        screenList: [],
        selectedLanguage: "en",
        lang_id:"1",
        end_time: "",
        start_time: "",
      };
    },
    beforeMount() {
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      this.getCinemaList();
    },
    watch: {

        fromDate() {
          this.getCashierSettlementReport("N", "N", "filter");
        },
        toDate() {
          this.getCashierSettlementReport("N", "N", "filter");
        },
    },
    mounted() {},
    computed: {
      currentSelectedLanguage() {
        return this.$store.getters.GET_SELECTED_HEADER_LANGUAGE;
      },
       disablePastDates() {
              const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            tomorrow.setHours(0, 0, 0, 0); 
            return {
              from: tomorrow 
            };
          },
    },
    methods: {
      moment,
      onChangeDate: function (e, type){
                if(type == 'from'){
                    this.toDate = new Date(e);
                    this.$forceUpdate();
                }
            },
      getCinemaList: function () {
        MasterService.GetCinemas()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.dropDown.cinemas = data.Records;
              this.CinemasCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectCinema: function (event) {
        this.dropDown.selectedCinema = event;
        this.dropDown.selectedCinemaName = event.cine_name;
        this.dropDown.selectedCinemaId = event.cine_id;
        this.dropDown.selectedCinemaAddres = event.cine_address;
        this.$store.dispatch("selectDropdownCinema", event);
        this.getCinemaScreens();
      },
      onSubmit() {
        this.getCashierSettlementReport();
      },
      async getCinemaScreens(index) {
        try {
          const response = await MasterService.GetActiveList({
            tableName: "screens",
            screen_is_active: "Y",
            cinema_id: this.dropDown.selectedCinemaId,
          });
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.screenList = data.Records;
          } else {
            console.log("show error:", data.message);
          }
        } catch (error) {
          this._CatchError(error);
        }
      },
      async getCashierSettlementReport(isPdf = "N",isExcel="N",type = "") {
        this.showData = []
        if (!this.dropDown.selectedCinemaId) {
          return this.$toasted.show("Select Cinema");
        }
        if (!this.fromDate) {
          return this.$toasted.show("Select From Date");
        }
        let loader;
        try {
          let screen_id = [];
                  if (this.selectedScreen.length) {
                   screen_id = this.selectedScreen.map((screen) => ({ screen_id: screen.screen_id, screen_name: screen.screen_name }));
                   }
          loader = this.$loading.show();
          let payload = {
            cinema_id: this.dropDown.selectedCinemaId,
            cinema_name: this.dropDown.selectedCinemaName,
            cinema_address: this.dropDown.selectedCinemaAddres,
            fromDate: this.fromDate,
            toDate: this.toDate,
            screen_id: screen_id.map(s => s.screen_id),    
            screen_name: screen_id.map(s => s.screen_name), 
            isPdf,
            isExcel,
            lang_id:this.lang_id,
            language: this.selectedLanguage,
            start_time:this.start_time,
            end_time:this.end_time,
          };
           if (type === "filter") {
              payload["type"] = "filter";
            }
          
              if (this.selectedMovieName.length) {
                payload["selectedMovieName"] = this.selectedMovieName.map(
                  (item) => {
                    return item.movie_name;
                  }
                );
              }
          let response = await NewReportService.getCashierAnalysisReport(
            payload
          );
          const { data } = response;
         if (!data.status) return this.$toasted.show(data.message);
            if (type == "filter") {
          this.allMovieNames = [...data.movieNamesData];
        } 
        else {
              console.log("data.Records=>",data.Records)
            this.showData = data.Records;
            this.grandTotal=data.grandTotal;
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
           else {
            this.$toasted.show(data.message);
          }
        } 
        } catch (error) {
          console.log(error);
        } finally {
          if (loader) {
            loader.hide();
          }
        }
      },
      updateLanguage(lang) {
        this.selectedLanguage = lang;
        // console.log("this.selectedLanguage:", this.selectedLanguage);
      },
  //     getRowspanForPaymentMode(mode) {
  //   return mode.paymentModeData.length;
  // },
  // getRowspanForSource(source) {
  //   return source.bookingSourceData.reduce((sum, mode) => sum + mode.paymentModeData.length, 0);
  // },
  // getRowspanForScreen(screen) {
  //   return screen.screenData.reduce((sum, source) =>
  //     sum + source.bookingSourceData.reduce((s, mode) => s + mode.paymentModeData.length, 0)
  //   , 0)+1;
  // },
  // getRowspanForUser(user) {
  //   return user.userData.reduce((sum, screen) =>
  //     sum + screen.screenData.reduce((sSum, source) =>
  //       sSum + source.bookingSourceData.reduce((mSum, mode) => mSum + mode.paymentModeData.length, 0)
  //     , 0)
  //   , 0);
  // }
  getRowspanForPaymentMode(mode) {
    return mode.paymentModeData.length;
  },
  getRowspanForSource(source) {
    return source.bookingSourceData.reduce((sum, mode) => sum + mode.paymentModeData.length, 0);
  },

  getRowspanForUser(user) {
  return user.userData.reduce((sum, screen) => {
    const screenTotal = screen.screenData.reduce((sSum, source) => {
      const sourceTotal = source.bookingSourceData.reduce((mSum, mode) => {
        return mSum + mode.paymentModeData.length;  mode
      }, 0);

      return sSum + sourceTotal + 1; 
    }, 0);

    return sum + screenTotal + 1; 
  }, 0);
},
getRowspanForScreen(screen) {
  const totalBookingSourceRows = screen.screenData.reduce((sum, source) => {
    const sourceTotal = source.bookingSourceData.reduce((s, mode) => s + mode.paymentModeData.length, 0);
    
    return sum + sourceTotal;
  }, 0);
  
  return totalBookingSourceRows + 1; 
}
    },
  };
  </script>
      
      <style>
  .concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
  }
  
  .concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
  }
  
  .concession-analysis-table thead th {
    padding: 5px;
    border: 1px solid #000;
  }
  
  .concession-analysis-table tbody {
    border-bottom: 1px solid #000;
  }
  
  .concession-analysis-table tbody td {
    padding: 2.5px 5px;
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
  }
  
  .concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
  }
  
  .gcamp-tr td {
    width: 13%;
    border: 1px solid #000;
  }
  
  .swc-report-table {
    table-layout: auto !important;
    border: 1px solid black;
  }
  
  .swc-report-table th {
    border: 1px solid black !important;
  }
  
  .swc_table_header th {
    border: 1px solid black !important;
  }
  .rtl-table {
    direction: rtl;
    text-align: right;
  }
  .rtl-table-scroll {
    direction: rtl;
  }
  .text_right{
    text-align: right;
  }
  .reverse-order{
    direction: rtl;
  }
  .order{
    direction: ltr
  }
  .blue-background{
    background-color:#EDF3FB
  }
  .dark-blue{
    background-color:#D4E3F5
  }
  </style>


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/cashierAnalysisReport.vue